import React, { useEffect, useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import RootContainer from 'components/custom/RootContainer';
import CustomPageIframe from 'components/custom/CustomPageIframe';
import CustomPageFooter from 'components/custom/CustomPageFooter';
import CustomHelmet from 'components/CustomHelmet';
import { useTranslation } from 'react-i18next';
import { selectLocale } from 'models/localization';
import { selectLocalizedEventName } from 'models/virtual_event';
import Routes from 'Routes';

const CustomPageContainer = () => {
  const { t } = useTranslation();
  const iframeRef: React.RefObject<HTMLIFrameElement> = useRef();
  const {
    pageNames: { custom },
    custom_page_source: customPageSource,
    features,
    customHtmlContent,
  } = useSelector((state: any) => state.eventConfigs);
  const eventName = useSelector(selectLocalizedEventName);

  const removeFooter = useMemo(() => features.includes('removeFooter'), [features]);

  useEffect(() => {
    if (customPageSource) return;
    const iframeElement: HTMLIFrameElement = iframeRef.current;
    if (customHtmlContent) {
      iframeElement.contentWindow.document.open();
      iframeElement.contentWindow.document.write(customHtmlContent);
      iframeElement.contentWindow.document.close();
    }
  }, [customPageSource, customHtmlContent]);

  const locale = useSelector(selectLocale);
  const pageTitle = custom?.[locale] || t('page.custom', 'Custom Page');

  const webTitle = pageTitle ? `${pageTitle} | ${eventName}` : eventName;

  return (
    <>
      <CustomHelmet>
        <meta charSet="utf-8" />
        <title>{webTitle}</title>
        <meta name="description" content={`${pageTitle} of ${eventName}.`} />
      </CustomHelmet>
      <RootContainer>
        <CustomPageIframe
          title={pageTitle}
          ref={iframeRef}
          width="100%"
          height="100%"
          src={customPageSource}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
        {!removeFooter && (
          <CustomPageFooter pathname={Routes.custom} />
        )}
      </RootContainer>
    </>
  );
};

export default CustomPageContainer;
